import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { IlluminateIcon, ExecuteIcon, KnowledgeIcon, AskIcon } from './TabBarIcons';

import { COLORS } from '../lib/theme';
import { t } from '../i18n/locale';
import { useLocaleStore } from '../stores/locale-store';

const tabs = [
  { path: '/illuminate', labelKey: 'nav.illuminate', Icon: IlluminateIcon },
  { path: '/ask', labelKey: 'nav.ask', Icon: AskIcon },
  { path: '/knowledge', labelKey: 'nav.knowledge', Icon: KnowledgeIcon },
  { path: '/execute', labelKey: 'nav.execute', Icon: ExecuteIcon },
] as const;

export function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const locale = useLocaleStore((s) => s.locale);

  return (
    <div className="app-container">
      <main
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: 96,
          maxWidth: 430,
          margin: '0 auto',
        }}
      >
        <Outlet />
      </main>

      {/* Bottom Tab Navigation — 半透明毛玻璃 · 零圆角 · VI 自然意象图标 */}
      <nav role="tablist" aria-label={t(locale, 'nav.main')} style={{
        position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
        width: '100%', maxWidth: 430, zIndex: 50,
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-around',
          minHeight: 56, paddingBottom: 'env(safe-area-inset-bottom)',
          boxSizing: 'content-box',
          background: 'rgba(247, 245, 240, 0.8)',
          backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
          borderTop: '1px solid rgba(44, 42, 41, 0.08)',
        }}>
          {tabs.map((tab) => {
            const isActive = location.pathname === tab.path || location.pathname.startsWith(`${tab.path}/`);
            const label = t(locale, tab.labelKey);
            return (
              <button
                key={tab.path}
                role="tab"
                aria-selected={isActive}
                aria-label={label}
                onClick={() => navigate(tab.path)}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center',
                  justifyContent: 'center', flex: 1, height: '100%', gap: 2,
                  background: 'none', border: 'none', cursor: 'pointer',
                  position: 'relative', padding: 0,
                }}
              >
                {isActive && (
                  <div
                    style={{
                      position: 'absolute', top: -8,
                      left: '50%', transform: 'translateX(-50%)',
                      width: 24, height: 2, background: COLORS.clay,
                    }}
                  />
                )}
                <tab.Icon
                  size={22}
                  color={isActive ? COLORS.clay : COLORS.ash}
                  strokeWidth={isActive ? 1.8 : 1.5}
                />
                <span style={{
                  fontSize: 10, letterSpacing: '0.08em',
                  color: isActive ? COLORS.sumi : COLORS.ash,
                  fontWeight: isActive ? 500 : 400,
                  transition: 'color 0.3s',
                }}>
                  {label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
